import { ActionButton } from '@fluentui/react';
import ChatButton from '../../../common/views/ChatButton';
import { Utils } from '../../../common/views/Utils';
import { ShortPaymentModel, PaymentType } from '../../models/PaymentModels';

export type PaymentItemProps = {
    payment: ShortPaymentModel;
    onDetail: (payment: ShortPaymentModel) => void;
}

export default function PaymentItemView({ payment, onDetail }: PaymentItemProps) {
    const width6 = Utils.getColumnWidth(6);

    const line1 = () => {
        const color = payment.isConfirmed ? "accepted" : "firmed";

        return <div className="ms-Grid-row ph-5">
            <div className={width6 + " font-bold left"}>
                {payment.id}
            </div>
            <div className={width6 + " right " + color}>
                {payment.isConfirmed ? "Confirmed" : "Not Confirmed"}
            </div>
        </div>;
    }

    const line2 = () => {
        return <div className="ms-Grid-row pt-10 ph-5">
            <div className={width6 + " left"}>
                {Utils.formatShortDate(payment.transactionDate)}
            </div>
            <div className={width6 + " right"}>
                {Utils.toCapital(PaymentType[payment.type])}
            </div>
        </div>;
    }

    const line3 = () => {
        const balance = payment.amount - payment.paidAmount;

        return <div className="ms-Grid-row pt-10 ph-5">
            <div className={width6 + " left"}>
                {payment.account.provider}-{payment.account.account}
            </div>
            <div className={width6 + " right font-bold"}>
                $ {payment.amount.toFixed(2)} / $ {balance.toFixed(2)}
            </div>
        </div>;
    }

    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width6 + " left"}>
                <ChatButton />
            </div>

            <div className={width6 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "NumberedListTextMirrored" }}
                    onClick={() => onDetail(payment)}
                >Detail</ActionButton>
            </div>
        </div>;
    }

    return <div className="ph-15">
        <div className="ms-Grid pt-10 default-border">
            {line1()}
            {line2()}
            {line3()}
            <div className="pt-10">
                {actionRow()}
            </div>
        </div>
    </div>;
}